import { render } from "./SignOut.vue?vue&type=template&id=320c1e3a&scoped=true"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"

import "./SignOut.vue?vue&type=style&index=0&id=320c1e3a&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320c1e3a"]])

export default __exports__